import React, { Component } from "react";
import styled from "styled-components";
import { injectStripe, CardElement } from "react-stripe-elements";
import { Prices } from "../../../constants/prices";
import { newJobFormValidation } from "../../../form-validations";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { showMessage } from "../../../store/actions/messenger-actions";
import { connect } from "react-redux";
import { hideLoader, showLoader } from "../../../store/actions/loading-actions";

const CardElementWrapper = styled.div`
  margin-bottom: 30px;
  margin-top: 5px;
  border: 1px solid #ddd;
  padding: 15px;
  background-color: #fff;
  border-radius: 3px;
`;

class PaymentForm extends Component {
  constructor(props) {
    super(props);
    this.validator = newJobFormValidation;
    this.state = {
      element: "",
      btnDisabled: false,
    };
  }

  handleReady = (element) => {
    this.setState({ element });
  };

  handleClick = (ev) => {
    ev.preventDefault();
    const {
      formState,
      pushLocation,
      setValidation,
      submitNewJob,
      showErrorMessage,
      showLoadingScreen,
      hideLoadingScreen,
      intent,
    } = this.props;
    this.setState({ btnDisabled: true });

    const validate = this.validator.validate(formState);

    // Validate all fields
    if (validate.isValid) {
      if (!!formState.rwa) {
        submitNewJob(formState, pushLocation, null, 0);
      } else {
        showLoadingScreen();
        // Test cards - https://stripe.com/docs/testing#cards

        // Payment
        this.props.stripe
          .handleCardPayment(intent, this.state.element)
          .then((result) => {
            if (result.error) {
              // TODO Show something for errors here.
              hideLoadingScreen();
              showErrorMessage(result.error.message);
              this.setState({ btnDisabled: false });
            } else {
              // Can assume payment successful.
              const IntentId = result.paymentIntent.id;
              submitNewJob(formState, pushLocation, IntentId);
            }
          });
      }
    } else {
      this.setState({ btnDisabled: false });
      setValidation(this.validator.validate(formState));
    }
  };

  render() {
    return (
      <form>
        <Label
          title={"Card Details*"}
          tooltipTitle="Payment is securely powered by Stripe"
        />
        <CardElementWrapper>
          <CardElement onReady={this.handleReady} />
        </CardElementWrapper>
        <Button
          isDisabled={this.state.btnDisabled}
          title={`Post job - $${Prices.single_job}/30 days`}
          path="/"
          fullWidth={true}
          align={"center"}
          click={this.handleClick}
        />
      </form>
    );
  }
}
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => {
  return {
    showErrorMessage(message) {
      dispatch(showMessage(message));
    },
    showLoadingScreen() {
      dispatch(showLoader());
    },
    hideLoadingScreen() {
      dispatch(hideLoader());
    },
  };
};

export const InjectedPaymentForm = injectStripe(
  connect(mapStateToProps, mapDispatchToProps)(PaymentForm)
);
